<template>
    <v-container fluid>
      <v-alert
              dense
              :type="alert.type"
              timeout="5000"
              v-if="alert.message">
          {{ alert.message }}
      </v-alert>
        <v-card>
          <v-card-title>HWID BYPASS</v-card-title>
          <v-card-text>
            <div class="pa-1 ma-1">
              <p class="red--text">*** CHANGE VALUE BY PUT HWID AND NEW VALUE ***</p>
              <v-row>
                <v-text-field
                  v-model="put.hwid"
                  label="HWID"
                  class="mx-1 col-4"
                  clearable
                />
                <v-text-field
                  v-model="put.val"
                  label="Value(Number)"
                  class="mx-1 col-2"
                  clearable
                />
                <v-btn
                  color="green"
                  class="mx-1"
                  @click="doPut()"
                  :loading="loading_put"
                  :disabled="loading_put || (!put.hwid || !put.val)"
                  :dark="loading_put"
                >
                  Put
                </v-btn>
              </v-row>
            </div>
          </v-card-text>
          <v-card-text>
            <v-btn
              color="green"
              class="mx-1"
              @click="doFetch()"
              :loading="loading"
              :disabled="loading"
              :dark="loading"
            >
              Reload
            </v-btn>
            <v-text-field
                v-model="hwid"
                label="Search by HWID"
                class="mx-1"
                clearable
            />
          </v-card-text>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-center blue--text text-h6">
                    HWID
                  </th>
                  <th class="text-center blue--text text-h6">
                    VALUE
                  </th>
                  <th class="text-center blue--text text-h6">
                    ACTION
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item,index) in filted_list"
                    :key="index"
                >
                  <td class="text-center blue--text text-h6">{{ item.hwid }}</td>
                  <td class="text-center blue--text text-h6">{{ item.val }}</td>
                  <td class="text-center blue--text text-h6">
                    <v-btn
                      color="red"
                      size="small"
                      dark
                      :loading="loading_manual_remove === index+1"
                      :disabled="loading_manual_remove === index+1"
                      @click="doRemove(item.hwid, index+1)"
                    >
                      Remove
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import {fetchData} from "../helpers";
import { mapState, mapActions } from 'vuex';
export default {
  name: "HWIDBYPASS",
  data(){
    return {
        put:{
            hwid: null,
            val: null,
        },
        hwids:{},
        hwid: null,
        loading: false,
        loading_manual_remove: null,
        loading_put: false,
    }
  },
  computed:{
    ...mapState({
        alert: state => state.alert
    }),
    API(){
      return `${this.$API}/api/HWID-BYPASS`;
    },
    filted_list(){
      const data = [];
      for(let k in this.hwids){
        if(this.hwid == null || this.hwids[k].includes(this.hwid)){
          data.push({
            hwid: k,
            val: this.hwids[k]
          });
        }
      }
      return data;
    }
  },
  methods:{
    ...mapActions('alert', ['success', 'error']),
    doFetch(){
      this.loading = true;
      fetchData(`${this.API}/list`)
        .then((json)=>{
          this.hwids = json;
        }).finally(()=>this.loading = false);
    },
    doPut(){
      if(!this.put.hwid || !this.put.val){
        this.error("Please input hwid and value");
        return;
      };
      this.loading_put = true;
      fetchData(`${this.API}/put`,this.put).then(json=>this.hwids = json).finally(()=>this.loading_put = false);
    },
    doRemove(hwid, index){
      this.loading_manual_remove = index;
      fetchData(`${this.API}/remove`, {hwid}).then(json=>this.hwids = json).finally(()=>this.loading_manual_remove = null);
    },
  },
  mounted() {
    this.doFetch();
  }
}
</script>